











































































































import BaseComponent from "@/components/base/BaseComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {Component} from 'vue-property-decorator';
import {Action} from "vuex-class";

@Component({})
export default class FundsYieldsPopupContentComponent extends BaseComponent {
  @Action("fundsYieldsDetails", StoreNamespace.FUND) fundsYieldsDetails: any;
  @Action("updateFundYield", StoreNamespace.FUND) updateFundYield: any;

  private fundYieldsDetailsList: any[] = [];
  private searchTerm: string = '';
  private editingFundId: string | null = null;
  private originalYieldValue: string | null = null;

  mounted() {
    this.fundsYieldsDetails({
      requestorCallback: this,
    });
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {

    switch (requestName) {
      case 'fundsYieldsDetails' :
        this.fundYieldsDetailsList = data;
        break;

      case 'updateFundYield' :
        this.editingFundId = null;
        this.originalYieldValue = null;
        this.showSuccessAction()
        break
    }
  }

  get filteredFunds() {
    if (!this.fundYieldsDetailsList.length) {
      return [];
    }

    const term = this.searchTerm.trim().toLowerCase();

    if (!term) {
      return this.fundYieldsDetailsList.map(fundType => {
        return {
          ...fundType,
          filteredFunds: [...fundType.fundYieldResponseList]
        };
      });
    }

    return this.fundYieldsDetailsList
        .map(fundType => {
          const copy = {...fundType};

          copy.filteredFunds = fundType.fundYieldResponseList.filter((fund: any) => {
            const fundNumMatch = fund.fundNum.toString().toLowerCase().includes(term);
            const fundNameMatch = fund.fundName.toLowerCase().includes(term);

            return fundNumMatch || fundNameMatch;
          });

          return copy;
        })
        .filter(fundType => fundType.filteredFunds.length > 0);
  }

  isEditing(fund: any): boolean {
    return this.editingFundId === `${fund.fundNum}`;
  }

  startEdit(fund: any): void {
    if (this.editingFundId) {
      this.cancelEdit({fundNum: this.editingFundId});
    }

    this.originalYieldValue = fund.fundYield;
    this.editingFundId = `${fund.fundNum}`;
  }

  saveEdit(fund: any): void {
    const newYield = parseFloat(fund.fundYield);
    fund.fundYield = fund.fundYield.includes("%") ? this.keepNumbersOnly(fund.fundYield) : fund.fundYield
    fund.prevYearFundYield = fund.prevYearFundYield.includes("%") ? this.keepNumbersOnly(fund.prevYearFundYield) : fund.prevYearFundYield

    if (isNaN(newYield)) {
      this.$root.$emit('showAlertNotification', {
        toShow: true,
        message: 'יש להזין מספר בין סכום אחוזים תקין',
        icon: 'warning',
        secondsToDisappear: 3
      })
      return;
    }

    const body = {
      fundNum: fund.fundNum,
      fundYield: fund.fundYield,
      prevYearFundYield: fund.prevYearFundYield
    }

    fund.fundYield = fund.fundYield + '%'
    fund.prevYearFundYield = fund.prevYearFundYield + '%'

    this.updateFundYield({
      requestorCallback: this,
      requestBody: body
    });
  }

  private showSuccessAction() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: 'loanConfiguration.updatedSuccessfully',
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  cancelEdit(fund: any): void {

    if (this.originalYieldValue !== null) {
      this.fundYieldsDetailsList.forEach(fundType => {
        fundType.fundYieldResponseList.forEach((f: any) => {
          if (f.fundNum === fund.fundNum) {
            f.fundYield = this.originalYieldValue;
          }
        });
      });
    }

    this.editingFundId = null;
    this.originalYieldValue = null;
  }

  keepNumbersOnly(input: string): string {

    const match = input.match(/-?\d+(\.\d+)?/);
    return match ? match[0] : '';
  }
}
